/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserDto
 */
export interface GetUserDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    id: string;
}

/**
 * Check if a given object implements the GetUserDto interface.
 */
export function instanceOfGetUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function GetUserDtoFromJSON(json: any): GetUserDto {
    return GetUserDtoFromJSONTyped(json, false);
}

export function GetUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function GetUserDtoToJSON(value?: GetUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

